import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import ContactUs from "../components/ContactUs";

export default function ContactUsPage() {
  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>Contact Us | MeraGym</title>
          <meta name="description" content="Get in touch with MeraGym. Have a question, partnership inquiry, or need support? Reach us by email, phone, or our contact form." />
          <meta name="keywords" content="contact meragym, meragym support, gym listing enquiry, meragym phone, meragym email, gym partnership India" />
          <link rel="canonical" href="https://meragym.com/contact-us" />
          <meta property="og:title" content="Contact Us | MeraGym" />
          <meta property="og:description" content="Reach out to MeraGym for queries, partnerships, or support. We respond within 24 hours." />
          <meta property="og:url" content="https://meragym.com/contact-us" />
        </Helmet>
      </HelmetProvider>
      <ContactUs />
    </>
  );
}
